import { EntityRequest } from "../entity/EntityRequest";
import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoRequestEntmtsGetRes } from "./abst/DtoRequestEntmtsGetRes";

export class DtoRequestEntmtsGetResImple extends DtoRequestEntmtsGetRes {
  public request = new EntityRequest();
  
  public pager = new DtoApiPager();
}
